import { z } from 'zod';
import { addPublishWindowIssues, adminMetadataSchema, contentStatusChangeSchema, imageReferenceSchema, nonEmptyUpdate, publishWindowShape, safeLinkSchema, slugSchema, } from './common.js';
const partnerEditableShape = {
    slug: slugSchema,
    nombre: z.string().min(1),
    logoUrl: imageReferenceSchema.nullable(),
    sitioUrl: safeLinkSchema.nullable(),
    orden: z.number().int(),
};
const partnerWriteShape = { ...partnerEditableShape, ...publishWindowShape };
export const createPartnerSchema = z
    .object({
    ...partnerEditableShape,
    orden: partnerEditableShape.orden.optional(),
    status: publishWindowShape.status.optional(),
    publishAt: publishWindowShape.publishAt.optional(),
    unpublishAt: publishWindowShape.unpublishAt.optional(),
})
    .superRefine(addPublishWindowIssues);
export const updatePartnerSchema = nonEmptyUpdate(z.object(partnerWriteShape));
export const partnerStatusChangeSchema = contentStatusChangeSchema;
export const publicPartnerSchema = z.object({
    nombre: partnerEditableShape.nombre,
    logoUrl: partnerEditableShape.logoUrl,
    sitioUrl: partnerEditableShape.sitioUrl,
});
export const publicPartnerListSchema = z.array(publicPartnerSchema);
export const publicPartnerFields = Object.freeze(Object.keys(publicPartnerSchema.shape));
export const adminPartnerSchema = z
    .object({ id: z.number().int().positive(), ...partnerWriteShape })
    .extend(adminMetadataSchema.shape);
export const adminPartnerListSchema = z.array(adminPartnerSchema);
export const partnerPreviewSchema = z.object({
    content: publicPartnerSchema,
    effectiveVisibility: adminMetadataSchema.shape.effectiveVisibility,
    publishAt: publishWindowShape.publishAt,
    unpublishAt: publishWindowShape.unpublishAt,
});
//# sourceMappingURL=partners.js.map